<router-outlet></router-outlet>
<bcu-alert></bcu-alert>
<bcu-spinner></bcu-spinner>
<bcu-modal></bcu-modal>